<template>
	<div id="app">
		<!-- Modal Sobre -->
		<ModalSobre :visible="showModal" />
		<!-- Navigation-->
		<nav
			class="navbar navbar-expand-lg navbar-dark bg-default fixed-top"
			id="mainNav"
		>
			<div class="d-flex">
				<b-button
					v-b-toggle.menuCollapsed
					class="navbar-toggler navbar-toggler-right"
				>
					<span class="navbar-toggler-icon"></span>
				</b-button>
				<span>
					<img
						src="../../../public/assets/img/max_compliance_logo.jpeg"
						alt="logo"
						id="logo-responsivo"
					/>
				</span>
			</div>

			<b-collapse id="menuCollapsed" class="navbar-collapse o-hidden">
				<img src="../../../public/assets/img/max_compliance_logo.jpeg" alt="logo" id="logo" />

				<ul class="navbar-nav navbar-sidenav pt-4">
					<li
						class="nav-item"
						data-toggle="tooltip"
						data-placement="right"
						title="Painel"
					>
						<router-link class="nav-link" exact to="/adm_master/painel">
							<i class="fa fa-fw fa-dashboard"></i>
							<span class="nav-link-text"> Painel </span>
						</router-link>
					</li>

					<li
						class="nav-item"
						data-toggle="tooltip"
						data-placement="right"
						title="Denúncias"
					>
						<router-link class="nav-link" exact to="/adm_master/denuncias">
							<i class="fa fa-fw fa-bullhorn"></i>
							<span class="nav-link-text"> Denúncias </span>
						</router-link>
					</li>

					<li
						class="nav-item"
						data-toggle="tooltip"
						data-placement="right"
						title="Empresas"
					>
						<a class="nav-link">
							<i class="fa fa-fw fa-briefcase"></i>
							<span 
                class="nav-link-text"
                @click="expandEmpresas = !expandEmpresas">
                 Empresas 
              </span>
              <router-link
                v-if="expandEmpresas"
                class="nav-link"
                exact to="/adm_master/empresas"
              >
                <i class="fa fa-fw fa-briefcase"></i>
                <span class="nav-link-text"> Empresas </span>
              </router-link>
              <router-link
                v-if="expandEmpresas"
                class="nav-link"
                exact to="/adm_master/unidades"
              >
                <i class="fa fa-fw fa-building"></i>
                <span class="nav-link-text"> Unidades </span>
              </router-link>
              <router-link
                v-if="expandEmpresas"
                class="nav-link"
                exact to="/adm_master/usuarios"
              >
                <i class="fa fa-fw fa-users"></i>
                <span class="nav-link-text"> Usuários </span>
              </router-link>
						</a>
					</li>

					<li
						class="nav-item"
						data-toggle="tooltip"
						data-placement="right"
						title="Sobre"
					>
						<button
							class="nav-link bt-open-sobre"
							exact
							to="/adm_prestadora/sobre"
							@click="showModal = !showModal"
						>
							<i class="fa fa-fw fa-info"></i>
							<span class="nav-link-text"> Sobre </span>
						</button>
					</li>
				</ul>

        <ul class="navbar-nav ml-auto">
					<li class="nav-item">
						<a style="color: white;">
              <i class="fa fa-fw fa-user"></i>
							<span v-text="nomeUsuario"></span>
						</a>
					</li>
				</ul>

				<ul class="navbar-nav ml-5">
					<li class="nav-item">
						<a class="nav-link" @click="logOut()">
							<i class="fa fa-fw fa-sign-out"></i>Logout
						</a>
					</li>
				</ul>
			</b-collapse>
		</nav>
		<!-- /Navigation-->

		<!-- Conteudo-->
		<router-view />
		<!-- /Conteudo-->
	</div>
</template>
<script>
import { verificaSeEstaLogado, alerta } from "../../utils/util";
import ModalSobre from "@/components/ModalSobre";

export default {
	components: {
		ModalSobre
	},
	data() {
		return {
			logado: false,
			nomeUsuario: "",
			showModal: false,
      expandEmpresas: false
		};
	},
	mounted() {
		var self = this
		var user = verificaSeEstaLogado()
		if (!user) {
			alerta("error", "Usuário não está logado")
			self.$router.replace(this.$route.query.redirect || "/")
			self.logado = false
		} else {
			if (user.role != 1) {
				window.history.length > 1
					? self.$router.go(-1)
					: self.$router.replace(this.$route.query.redirect || "/")

			} else {
				self.logado = true
				self.nomeUsuario = user.name
			}
		}
	},
	methods: {
		logOut() {
			localStorage.removeItem("token_max")
			this.$router.push("/")
		}
	}
};
</script>
<style scoped>
@media (min-width: 992px) {
	#mainNav.fixed-top .navbar-sidenav {
		height: calc(100vh);
	}

	#logo {
		height: 50px;
		display: block !important;
		margin-left: 45px;
	}

	#logo-responsivo {
		display: none;
	}
}

#logo {
	display: none;
}

#logo-responsivo {
	height: 40px;
	margin-left: 5vh;
}

.bt-open-sobre:hover {
	text-decoration: underline;
}
</style>
